document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-fu-s4-img.z-ani-o', { opacity: 0, y: 20, x: 5 });
    gsap.set('.co-fu-s4-text .z-ani-o', { opacity: 0, y: 40 });
    let cFUS1Tl1 = gsap.timeline({ paused: true });
    cFUS1Tl1.to('.co-fu-s4-img.z-ani-o', {
        y: 0,
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut"
    });
    cFUS1Tl1.to('.co-fu-s4-text .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-fu-s4-text .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cFUS1Tl1
    });
});